import { render, staticRenderFns } from "./introduction.vue?vue&type=template&id=ffd5d5a0&scoped=true"
import script from "./introduction.vue?vue&type=script&lang=js"
export * from "./introduction.vue?vue&type=script&lang=js"
import style0 from "./introduction.vue?vue&type=style&index=0&id=ffd5d5a0&prod&lang=scss&scoped=true"
import style1 from "./introduction.vue?vue&type=style&index=1&id=ffd5d5a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd5d5a0",
  null
  
)

export default component.exports